var React = require('react');

function ArrowPopupPlayer (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.49986 2.00038C1.50001 24.4998 9.50007 48.2711 56.0185 46.4049M49.5 50.5C52 47 55.7098 46.8162 57.2744 46.6342C50.5002 43.4998 50.5863 40.6015 50.0167 39.4998","stroke":"white","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowPopupPlayer.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = ArrowPopupPlayer;

ArrowPopupPlayer.default = ArrowPopupPlayer;
